import { render, staticRenderFns } from "./WorkflowDialog.vue?vue&type=template&id=5c59488d&scoped=true"
import script from "./WorkflowDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDialog.vue?vue&type=style&index=0&id=5c59488d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c59488d",
  null
  
)

export default component.exports